export default __webpack_public_path__ + "images/about/2 Оксана Вдовина ведущий дизайнер.jpg";